import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDPrimaryActionButton, FDSecondaryActionButton, FDStack } from '@facet-wealth/design';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { Alert } from 'Packages/FacetDesign/Components/Alert';
import React from 'react';
import { DialogActions, DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import PropTypes from 'prop-types';
import WizardStepDeleteButton from 'Views/Page/Content/Modal/Layouts/DefaultFDWizardStep/Layout/WizardStepDeleteButton';
import { useSnackbarContext } from 'Context/SnackbarContext';
import fr from 'facet-rest';
import { ProfileImageUploader } from 'Components/ComponentLibrary/Organisms/ProfileImageUploader';
import { dataAttrs } from 'Helpers/Testing';
import VerifyIdentity from 'Components/ComponentLibrary/Organisms/ClientDetailForm/VerifyIdentity/VerifyIdentity';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';


export const AddOrEditHouseholdMemberLayout = ({ onCloseModal, onProfileImageUpload }) => {
  const {
    errors, onSubmit, resource, saving,
  } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();

  const onDelete = async () => {
    try {
      await resource.delete();
    } catch (err) {
      displayErrorMessage(err, err.message);
    }
  };

  const onDeleteSuccess = () => {
    onCloseModal();
  };

  const VerificationComponent = resource.withRelationship(fr.relationships.kycIdentityVerification.name,
    (rel) => <VerifyIdentity relationship={rel} />,
    () => null);

  return (
    <>
      <DialogTitle
        value={(
          <FDStack direction="row" width="100%" spacing={3} wrap justifyContent="space-between">
            {resource.id() ? 'Edit household member' : 'Add household member'}
            <MetaControlField attr={'isIdentityVerified'} />
          </FDStack>
        )}
      />
      <DialogContent>
        <FDStack direction={'column'} spacing={2}>
          {VerificationComponent}
          <MetaLayoutRemainingFields />
          {resource.withRelationship(fr.relationships.profileImage.name, (rel) => {
            return (
              <FDStack justifyContent={'flex-start'}>
                <ProfileImageUploader
                  profileImageRelationship={rel}
                  onSuccess={onProfileImageUpload}
                />
              </FDStack>
            );
          }, () => null)}
          {errors.length ? <Alert
            status={'error'}
            title={'Errors saving'}
            details={errors.map((e) => e.detail)}
          /> : null}
          {resource.meta().canDelete() ? <WizardStepDeleteButton
            onDelete={onDelete}
            onDeleteSuccess={onDeleteSuccess}
            dialogProps={{
              title: 'Are you sure?',
              message: 'Removing this household member will delete all of their information. This cannot be undone.',
              cancelLabel: 'Nevermind',
              confirmLabel: 'Remove',
            }}
          /> : null}
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDSecondaryActionButton label={'Cancel'} onClick={onCloseModal} />
        {resource.meta().canSubmit() ? <FDPrimaryActionButton
          {...dataAttrs('modal-save-btn', resource)}
          loading={saving}
          label={'Save'}
          onClick={() => onSubmit()}
        /> : null}
      </DialogActions>
    </>
  );
};

AddOrEditHouseholdMemberLayout.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onProfileImageUpload: PropTypes.func.isRequired,
};
